import { render, staticRenderFns } from "./SchoolTerm.vue?vue&type=template&id=4929f4d2"
import script from "./SchoolTerm.vue?vue&type=script&lang=js"
export * from "./SchoolTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports